import { graphql } from "../gql";

// Query all AI chatbots

export const listQuery = graphql(`
    query AiChatbotsListQuery {
        currentPerson {
            id
            standaloneAiChatbots {
                id
                name
                description
            }
        }
    }
`);

// Start thread mutation

export const startMutation = graphql(`
    mutation AiChatbotsStartMutation($id: ID!) {
        standaloneAiThreadCreate(id: $id) {
            error
            standaloneAiThread {
                id
            }
        }
    }
`);

// Continue thread mutation

export const continueMutation = graphql(`
    mutation AiChatbotsContinueMutation($id: ID!, $content: String!) {
        standaloneAiThreadContinue(id: $id, content: $content) {
            error
            standaloneAiThread {
                id
                aiThreadItems {
                    id
                    type
                    role
                    content
                }
            }
        }
    }
`);

// Query Ai Thread

export const threadQuery = graphql(`
    query AiChatbotsThreadQuery($id: ID!) {
        standaloneAiThread(id: $id) {
            id
            aiThreadItems {
                id
                type
                role
                content
            }
            standaloneAiChatbot {
                id
                name
                description
            }
        }
    }
`);

// Query Ai Thread list

export const threadListQuery = graphql(`
    query AiChatbotsThreadListQuery {
        currentPerson {
            id
            standaloneAiThreads {
                id
                created
                aiThreadItems {
                    id
                    type
                    role
                    content
                }
                standaloneAiChatbot {
                    id
                    name
                }
            }
        }
    }
`);
